import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { Button, TransitionablePortal, Modal, Icon } from "semantic-ui-react";
import { RemoveCGMBranch, SetCGMBranches } from "../../../../../../actions/cgmBranchesActions";
import { AppState } from "../../../../../../store/configureStore";
import { CriticalBranchDisplay } from "../CCValidationViews/CriticalBranchDisplay";

export const ViewSavedCriticalBranches = () => {
    const dispatch = useDispatch();
    const { cgmBranches } = useSelector((state: AppState) => state.cgmBranches);
    const [cgmModalOpen, setCgmModalOpen] = useState(false);
    const [clearModalOpen, setClearModalOpen] = useState(false);

    const handleConfirm = () => {
        dispatch(SetCGMBranches([]));
        setClearModalOpen(false);
    };

    useEffect(() => {
        if (cgmBranches.length === 0) setCgmModalOpen(false);
    }, [cgmBranches.length]);

    return (
        <>
            <CSSTransition
                id="CSSTransition-viewSavedCriticalBranches-a"
                in={cgmBranches.length > 0}
                timeout={400}
                classNames="neselector-transition"
                unmountOnExit
            >
                <div id="div-viewSavedCriticalBranches-a" className="saved-elements-actions">
                    <Button id="button-viewSavedCriticalBranches-close" icon="close" size="tiny" onClick={() => setClearModalOpen(true)} />
                    <Button
                        id="button-viewSavedCriticalBranches-a"
                        content="View saved critical branches"
                        size="tiny"
                        onClick={() => setCgmModalOpen(true)}
                    />
                </div>
            </CSSTransition>
            <TransitionablePortal
                id="transitionablePortal-viewSavedCriticalBranches-a"
                open={cgmModalOpen}
                onOpen={() => setTimeout(() => document.body.classList.add("modal-fade-in"), 0)}
                transition={{ animation: "scale", duration: 300 }}
            >
                <Modal id="modal-viewSavedCriticalBranches-a" onClose={() => setCgmModalOpen(false)} open closeOnDimmerClick size="small">
                    <Modal.Header id="modalHeader-viewSavedCriticalBranches-a">Saved critical branches</Modal.Header>
                    <Modal.Content id="modalContent-viewSavedCriticalBranches-a">
                        {cgmBranches.map(x => (
                            <section id={`section-viewSavedCriticalBranches-a-${x.id}`} key={x.id} className="view-saved">
                                <CriticalBranchDisplay criticalBranch={x} />
                                <Icon
                                    id={`icon-viewSavedCriticalBranches-a-${x.id}`}
                                    name="close"
                                    size="large"
                                    link
                                    onClick={() => dispatch(RemoveCGMBranch(x))}
                                />
                            </section>
                        ))}
                    </Modal.Content>
                </Modal>
            </TransitionablePortal>
            <TransitionablePortal
                id="transitionablePortal-viewSavedCriticalBranches-b"
                open={clearModalOpen}
                onOpen={() => setTimeout(() => document.body.classList.add("modal-fade-in"), 0)}
                transition={{ animation: "scale", duration: 300 }}
            >
                <Modal id="modal-viewSavedCriticalBranches-b" dimmer="inverted" size="mini" open onClose={() => setClearModalOpen(false)}>
                    <Modal.Header id="modalHeader-viewSavedCriticalBranches-clearAll">
                        Are you sure you want to clear all critical branches?
                    </Modal.Header>
                    <Modal.Actions id="modalActions-viewSavedCriticalBranches-b">
                        <Button id="button-viewSavedCriticalBranches-no" content="No" onClick={() => setClearModalOpen(false)} />
                        <Button id="button-viewSavedCriticalBranches-yes" primary content="Yes" onClick={() => handleConfirm()} />
                    </Modal.Actions>
                </Modal>
            </TransitionablePortal>
        </>
    );
};
